import pulse from '@finn-no/pulse-sdk';

const trackViewButton = () =>
    pulse.trackEvent({
        type: 'View',
        intent: 'Contact',
        name: 'Purchase with delivery',
        object: {
            id: `tjt-create-offer-button-view`,
            type: 'UIElement',
            elementType: 'Button',
        },
        vertical: {
            name: 'bap',
            subVertical: 'transaction_journey_bap',
        },
    });



// TJT_ev01
const trackCreateOfferClick = (finnkode: string) =>
    pulse.trackEvent({
        type: 'Click',
        intent: 'Contact',
        name: 'Purchase with delivery',
        object: {
            id: `tjt-create-offer-button`,
            type: 'UIElement',
            elementType: 'Button',
            items: [
                {
                    type: 'ClassifiedAd',
                    id: finnkode,
                    contentId: finnkode,
                    name: 'n/a',
                    category: 'n/a',
                },
            ],
        },
        target: {
            id: finnkode,
            type: 'ProcessFlow',
            name: 'Transactionjourney bap',
        },
        vertical: {
            name: 'bap',
        },
    });

// TJT_ev16
const trackViewSuggestButton = (finnkode: string) =>
    pulse.trackEvent({
        type: 'View',
        intent: 'Show',
        name: 'Fiks ferdig',
        object: {
            id: `tjt-create-offer-button-view-suggest`,
            type: 'UIElement',
            elementType: 'Button',
            position: 'Classified ad',
            name: 'Request fiks ferdig',
            items: [
                {
                    type: 'ClassifiedAd',
                    id: finnkode,
                    contentId: finnkode,
                    name: 'N/A',
                    category: 'N/A'

                },
            ]
        },
        vertical: {
            name: 'bap',
        },
    });

// TJT_ev17
const trackViewAlreadySuggested = (finnkode: string) =>
    pulse.trackEvent({
        type: 'View',
        intent: 'Show',
        name: 'Fiks ferdig',
        object: {
            id: `tjt-create-offer-button-view-already-suggested`,
            type: 'UIElement',
            elementType: 'Podlet text',
            position: 'Classified ad',
            name: 'Waiting on fiks ferdig',
            items: [
                {
                    type: 'ClassifiedAd',
                    id: finnkode,
                    contentId: finnkode,
                    name: 'N/A',
                    category: 'N/A'

                },
            ]
        },
        vertical: {
            name: 'bap',
        },
    });
//  TJT_ev18
const trackViewSuggestShippingFailed = (finnkode: string) =>
    pulse.trackEvent({
        type: 'View',
        intent: 'Show',
        name: 'Fiks ferdig',
        object: {
            id: `tjt-create-offer-button-view-suggested-failed`,
            type: 'UIElement',
            elementType: 'Podlet text',
            position: 'Classified ad',
            name: 'Unable to request fiks ferdig',
            items: [
                {
                    type: 'ClassifiedAd',
                    id: finnkode,
                    contentId: finnkode,
                    name: 'N/A',
                    category: 'N/A'

                },
            ]
        },
        vertical: {
            name: 'bap',
        },
    })

//  TJT_ev19
const trackClickSuggestShipping = (finnkode: string) =>
    pulse.trackEvent({
        type: 'Click',
        intent: 'Request',
        name: 'Fiks ferdig',
        object: {
            id: `tjt-create-offer-button-click-suggest-shipping`,
            type: 'UIElement',
            elementType: 'Button',
            position: 'Classified ad',
            name: 'Request fiks ferdig',
            items: [
                {
                    type: 'ClassifiedAd',
                    id: finnkode,
                    contentId: finnkode,
                    name: 'N/A',
                    category: 'N/A'

                },
            ]
        },
        vertical: {
            name: 'bap',
        },
    })

//  TJT_ev22
const trackExpandFiksFerdig = (finnkode: string) =>
    pulse.trackEvent({
        type: 'Click',
        intent: 'Open',
        name: 'Fiks ferdig',
        object: {
            id: `tjt-create-offer-button-expand-FiksFerdigInfo`,
            type: 'UIElement',
            elementType: 'Sidebar',
            position: 'Classified ad',
            items: [
                {
                    type: 'ClassifiedAd',
                    id: finnkode,
                    contentId: finnkode,
                    name: 'N/A',
                    category: 'N/A'

                },
            ]
        },
        vertical: {
            name: 'bap',
        },
    })

//  TJT_ev23
const trackExpandShipping = (finnkode: string) =>
    pulse.trackEvent({
        type: 'Click',
        intent: 'Open',
        name: 'Delivery',
        object: {
            id: `tjt-create-offer-button-expand-ShippingInfo`,
            type: 'UIElement',
            elementType: 'Sidebar',
            position: 'Classified ad',
            items: [
                {
                    type: 'ClassifiedAd',
                    id: finnkode,
                    contentId: finnkode,
                    name: 'N/A',
                    category: 'N/A'

                },
            ]
        },
        vertical: {
            name: 'bap',
        },
    })

//  TJT_ev24
const trackExpandPayment = (finnkode: string) =>
    pulse.trackEvent({
        type: 'Click',
        intent: 'Open',
        name: 'Payment',
        object: {
            id: `tjt-create-offer-button-expand-PaymentInfo`,
            type: 'UIElement',
            elementType: 'Sidebar',
            position: 'Classified ad',
            items: [
                {
                    type: 'ClassifiedAd',
                    id: finnkode,
                    contentId: finnkode,
                    name: 'N/A',
                    category: 'N/A'

                },
            ]
        },
        vertical: {
            name: 'bap',
        },
    })

type PulseClientType = {
    trackViewButton: (
        finnkode: string
    ) => void;
    trackCreateOfferClick: (
        finnkode: string
    ) => void;
    trackViewSuggestButton: (
        finnkode: string
    ) => void;
    trackViewAlreadySuggested: (
        finnkode: string
    ) => void;
    trackViewSuggestShippingFailed: (
        finnkode: string
    ) => void;
    trackClickSuggestShipping: (
        finnkode: string
    ) => void;
    trackExpandFiksFerdig: (
        finnkode: string
    ) => void;
    trackExpandShipping: (
        finnkode: string
    ) => void;
    trackExpandPayment: (
        finnkode: string
    ) => void;

};

const pulseClient: PulseClientType = {
    trackViewButton,
    trackViewSuggestButton,
    trackCreateOfferClick,
    trackViewAlreadySuggested,
    trackViewSuggestShippingFailed,
    trackClickSuggestShipping,
    trackExpandFiksFerdig,
    trackExpandShipping,
    trackExpandPayment
};

export default pulseClient;
